/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ManagerOnDuty,
  ManagerOnDutyRequest,
  PatchedManagerOnDutyRequest
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getManagersOnDutyListUrl = () => {




  return `/api/managers-on-duty/`
}

/**
 * Retrieves the list of managers on duty stored across all the locations where the current authenticated manager is a location manager
 */
export const managersOnDutyList = async ( options?: Parameters<typeof customFetch>[1]): Promise<ManagerOnDuty[]> => {

  return customFetch<ManagerOnDuty[]>(getManagersOnDutyListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getManagersOnDutyListQueryKey = () => {
    return [
    `/api/managers-on-duty/`
    ] as const;
    }


export const getManagersOnDutyListQueryOptions = <TData = Awaited<ReturnType<typeof managersOnDutyList>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof managersOnDutyList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getManagersOnDutyListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof managersOnDutyList>>> = ({ signal }) => managersOnDutyList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof managersOnDutyList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ManagersOnDutyListQueryResult = NonNullable<Awaited<ReturnType<typeof managersOnDutyList>>>
export type ManagersOnDutyListQueryError = void


export function useManagersOnDutyList<TData = Awaited<ReturnType<typeof managersOnDutyList>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof managersOnDutyList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof managersOnDutyList>>,
          TError,
          Awaited<ReturnType<typeof managersOnDutyList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useManagersOnDutyList<TData = Awaited<ReturnType<typeof managersOnDutyList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof managersOnDutyList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof managersOnDutyList>>,
          TError,
          Awaited<ReturnType<typeof managersOnDutyList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useManagersOnDutyList<TData = Awaited<ReturnType<typeof managersOnDutyList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof managersOnDutyList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useManagersOnDutyList<TData = Awaited<ReturnType<typeof managersOnDutyList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof managersOnDutyList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getManagersOnDutyListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getManagersOnDutyCreateUrl = () => {




  return `/api/managers-on-duty/`
}

export const managersOnDutyCreate = async (managerOnDutyRequest: ManagerOnDutyRequest, options?: Parameters<typeof customFetch>[1]): Promise<ManagerOnDuty> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ManagerOnDuty>(getManagersOnDutyCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(managerOnDutyRequest)
  }
);}





export const getManagersOnDutyCreateMutationKey = () => ['managersOnDutyCreate'] as const;

export const getManagersOnDutyCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof managersOnDutyCreate>>, TError,ManagersOnDutyCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof managersOnDutyCreate>>, TError,ManagersOnDutyCreateMutationVariables, TContext> => {

const mutationKey = getManagersOnDutyCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof managersOnDutyCreate>>, ManagersOnDutyCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  managersOnDutyCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ManagersOnDutyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof managersOnDutyCreate>>>
    export type ManagersOnDutyCreateMutationBody = ManagerOnDutyRequest
    export type ManagersOnDutyCreateMutationError = void
    export type ManagersOnDutyCreateMutationVariables = {data: ManagerOnDutyRequest}

    export const useManagersOnDutyCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof managersOnDutyCreate>>, TError,ManagersOnDutyCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof managersOnDutyCreate>>,
        TError,
        ManagersOnDutyCreateMutationVariables,
        TContext
      > => {
      return useMutation(getManagersOnDutyCreateMutationOptions(options), queryClient);
    }
    export const getManagersOnDutyRetrieveUrl = (id: number,) => {




  return `/api/managers-on-duty/${id}/`
}

export const managersOnDutyRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<ManagerOnDuty> => {

  return customFetch<ManagerOnDuty>(getManagersOnDutyRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getManagersOnDutyRetrieveQueryKey = (id: number,) => {
    return [
    `/api/managers-on-duty/${id}/`
    ] as const;
    }


export const getManagersOnDutyRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof managersOnDutyRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof managersOnDutyRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getManagersOnDutyRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof managersOnDutyRetrieve>>> = ({ signal }) => managersOnDutyRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof managersOnDutyRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ManagersOnDutyRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof managersOnDutyRetrieve>>>
export type ManagersOnDutyRetrieveQueryError = void


export function useManagersOnDutyRetrieve<TData = Awaited<ReturnType<typeof managersOnDutyRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof managersOnDutyRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof managersOnDutyRetrieve>>,
          TError,
          Awaited<ReturnType<typeof managersOnDutyRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useManagersOnDutyRetrieve<TData = Awaited<ReturnType<typeof managersOnDutyRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof managersOnDutyRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof managersOnDutyRetrieve>>,
          TError,
          Awaited<ReturnType<typeof managersOnDutyRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useManagersOnDutyRetrieve<TData = Awaited<ReturnType<typeof managersOnDutyRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof managersOnDutyRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useManagersOnDutyRetrieve<TData = Awaited<ReturnType<typeof managersOnDutyRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof managersOnDutyRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getManagersOnDutyRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getManagersOnDutyUpdateUrl = (id: number,) => {




  return `/api/managers-on-duty/${id}/`
}

export const managersOnDutyUpdate = async (id: number,
    managerOnDutyRequest: ManagerOnDutyRequest, options?: Parameters<typeof customFetch>[1]): Promise<ManagerOnDuty> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ManagerOnDuty>(getManagersOnDutyUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(managerOnDutyRequest)
  }
);}





export const getManagersOnDutyUpdateMutationKey = () => ['managersOnDutyUpdate'] as const;

export const getManagersOnDutyUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof managersOnDutyUpdate>>, TError,ManagersOnDutyUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof managersOnDutyUpdate>>, TError,ManagersOnDutyUpdateMutationVariables, TContext> => {

const mutationKey = getManagersOnDutyUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof managersOnDutyUpdate>>, ManagersOnDutyUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  managersOnDutyUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ManagersOnDutyUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof managersOnDutyUpdate>>>
    export type ManagersOnDutyUpdateMutationBody = ManagerOnDutyRequest
    export type ManagersOnDutyUpdateMutationError = void
    export type ManagersOnDutyUpdateMutationVariables = {id: number;data: ManagerOnDutyRequest}

    export const useManagersOnDutyUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof managersOnDutyUpdate>>, TError,ManagersOnDutyUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof managersOnDutyUpdate>>,
        TError,
        ManagersOnDutyUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getManagersOnDutyUpdateMutationOptions(options), queryClient);
    }
    export const getManagersOnDutyPartialUpdateUrl = (id: number,) => {




  return `/api/managers-on-duty/${id}/`
}

export const managersOnDutyPartialUpdate = async (id: number,
    patchedManagerOnDutyRequest?: PatchedManagerOnDutyRequest, options?: Parameters<typeof customFetch>[1]): Promise<ManagerOnDuty> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ManagerOnDuty>(getManagersOnDutyPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedManagerOnDutyRequest)
  }
);}





export const getManagersOnDutyPartialUpdateMutationKey = () => ['managersOnDutyPartialUpdate'] as const;

export const getManagersOnDutyPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof managersOnDutyPartialUpdate>>, TError,ManagersOnDutyPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof managersOnDutyPartialUpdate>>, TError,ManagersOnDutyPartialUpdateMutationVariables, TContext> => {

const mutationKey = getManagersOnDutyPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof managersOnDutyPartialUpdate>>, ManagersOnDutyPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  managersOnDutyPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ManagersOnDutyPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof managersOnDutyPartialUpdate>>>
    export type ManagersOnDutyPartialUpdateMutationBody = PatchedManagerOnDutyRequest | undefined
    export type ManagersOnDutyPartialUpdateMutationError = void
    export type ManagersOnDutyPartialUpdateMutationVariables = {id: number;data?: PatchedManagerOnDutyRequest}

    export const useManagersOnDutyPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof managersOnDutyPartialUpdate>>, TError,ManagersOnDutyPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof managersOnDutyPartialUpdate>>,
        TError,
        ManagersOnDutyPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getManagersOnDutyPartialUpdateMutationOptions(options), queryClient);
    }
    export const getManagersOnDutyDestroyUrl = (id: number,) => {




  return `/api/managers-on-duty/${id}/`
}

export const managersOnDutyDestroy = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getManagersOnDutyDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getManagersOnDutyDestroyMutationKey = () => ['managersOnDutyDestroy'] as const;

export const getManagersOnDutyDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof managersOnDutyDestroy>>, TError,ManagersOnDutyDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof managersOnDutyDestroy>>, TError,ManagersOnDutyDestroyMutationVariables, TContext> => {

const mutationKey = getManagersOnDutyDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof managersOnDutyDestroy>>, ManagersOnDutyDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  managersOnDutyDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ManagersOnDutyDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof managersOnDutyDestroy>>>

    export type ManagersOnDutyDestroyMutationError = void
    export type ManagersOnDutyDestroyMutationVariables = {id: number}

    export const useManagersOnDutyDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof managersOnDutyDestroy>>, TError,ManagersOnDutyDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof managersOnDutyDestroy>>,
        TError,
        ManagersOnDutyDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getManagersOnDutyDestroyMutationOptions(options), queryClient);
    }
